<template>
  <div
    class="skeleton-form"
    :class="{ 'text-right': textRight, 'no-mock': hideMock }"
    :style="cssVars" >
    <span v-if="placeholder">{{ placeholder }}</span>
    <span
      v-if="!hideMock"
      class="dummy-text w5 no-shrink greedy" />
    <span
      v-if="!hideMock"
      class="dummy-text w70 no-shrink" />
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';

export default {
  name: 'SkeletonWrapper',
  components: {
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    schema: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    textColor: {
      type: String,
      default: SBColors.blackUltralight,
    },
    mockColor: {
      type: String,
      default: '#cfd5d8',
    },
    backgroundColor: {
      type: String,
      default: '#edf0f2',
    },
    width: {
      type: Number,
      default: 100,
    },
    shadow: {
      type: Boolean,
      default: true,
    },
    textRight: {
      type: Boolean,
      default: false,
    },
    topRadius: {
      type: Number,
      default: 10,
    },
    bottomRadius: {
      type: Number,
      default: 10,
    },
    hideMock: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cssVars() {
      return {
        '--width': `${this.width}%`,
        '--text-color': this.textColor,
        '--mock-color': this.mockColor,
        '--background-color': this.backgroundColor,
        '--shadow': this.shadow ? '0 1px 3px 0 rgba(48, 54, 70, 0.1)' : 'none',
        '--top-radius': `${this.topRadius}px`,
        '--bottom-radius': `${this.bottomRadius}px`,
      };
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.skeleton-form {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  padding: 10px 10px;
  background-color: var(--background-color);
  border-radius: 10px;
  border-top-left-radius: var(--top-radius);
  border-top-right-radius: var(--top-radius);
  border-bottom-left-radius: var(--bottom-radius);
  border-bottom-right-radius: var(--bottom-radius);
  box-shadow: var(--shadow);
  border: solid 1px $greyBorder;
  width: var(--width);
  max-width: var(--width);

  &.text-right {
    justify-content: flex-end;
  }

  &.no-mock {
    width: unset;
  }

  span {
    font-size: 14px;
    letter-spacing: normal;
    text-align: left;
    color: var(--text-color);
    font-style: italic;
  }

  .dummy-text {
    display: block;
    width: 80%;
    height: 13px;
    margin: 0;
    border-radius: 7px;
    background-color: var(--mock-color);

    &.w5 {
      width: 5%;
    }
    &.w40 {
      width: 40%;
    }
    &.w70 {
      width: 70%;
    }
    &.w85 {
      width: 85%;
    }
  }
}
</style>
